import { object, string, InferType } from 'yup'

export const linkSchema = object({
  type: string().oneOf(['internal', 'anchor', 'external', 'file', 'lightbox']),
  href: string(),
  target: string().oneOf(['_blank', '_self']),
}).noUnknown()

export type LinkType = InferType<typeof linkSchema>
